
import { useEffect } from "react"
import TablaBienesServicios from "../../../../EmitirFactura/Components/GeneracionFactura/TablaBienesServicios"
import Footer from "../../Footer"
import ViewDocV1 from "../forms/ViewDocV1"
import { useDispatch, useSelector } from "react-redux"
import { State } from "../../../../../reducers"

import { facturacionArrayProductosSet, facturacionSetTotalDocRelacionado } from "../../../../../actions/facturacion/facturacionProductos.actions"
import { ProductosF } from "../../../../../interfaces/facturacion.interface"
import FormProductosV1 from "../forms/productos/FormProductosV1"

export const NotaCredito = () => {
  const {activeFactura} = useSelector((state: State) => state.historial);
  const {activeDoc} = useSelector((state: State) => state.documentos);
  const {arrayProductos, calculosArrayProductos} = useSelector((state: State) => state.facturacion);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      if (arrayProductos.length > 0) { return; }
      
      // Cargar productos
      const cuerpo = activeFactura?.DetallesDTE?.cuerpoDocumento;
      let productos = [];
      
      if (Array.isArray(cuerpo)) productos = cuerpo;
      else productos = [cuerpo];

      const productosList:Array<ProductosF> = productos?.map((producto: any) => {
        const subtotal = producto?.precioUni * producto?.cantidad;
        const total = subtotal - producto?.montoDescu;
        const ivaItem = total * 0.13;
        const totalImpuesto1 = subtotal + ivaItem;
        const totalImpuesto1Desc = totalImpuesto1 - producto?.montoDescu;

        let retencion = 0;
        if (total > 100) {
          retencion = total * 0.01
        }

        return {
          descripcion: producto?.descripcion+"", 
          cantidad: producto?.cantidad+"",
          precio: producto?.precioUni+"",
          tipoDescuento: "monto",
          descuento: producto?.montoDescu+"",
          cantidadDescuento: producto?.montoDescu+"",
          subtotal: subtotal.toFixed(2),
          total: total.toFixed(2),
          totalImpuesto1: ivaItem.toFixed(2),
          totalImpuesto2: retencion ? retencion.toFixed(2) : "0.00",
          impuesto1: "13",
          impuesto2: retencion ? "1" : "0",
          totalConImpuesto1: totalImpuesto1.toFixed(2),
          subTotalConImpuesto1: "0.00",
          totalConImpuesto1Desc: totalImpuesto1Desc.toFixed(2),
        }
      })

      dispatch(facturacionArrayProductosSet(productosList));
    }, 1000)
  }, []);

  useEffect(() => {
    if (!calculosArrayProductos.totalDocRelacionado && calculosArrayProductos.totalConRetecion !== "0.00") {
      dispatch(facturacionSetTotalDocRelacionado(calculosArrayProductos.totalConRetecion));
    }
  }, [calculosArrayProductos]);

  return (
    <>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card w-form' style={{textAlign: 'center'}}>
          <label>DOCUMENTO DE REFERENCIA</label>
          <p>{activeFactura?.DetallesDTE?.identificacion?.numeroControl ?? "---"}</p>
        </div>   
      </div>
      <ViewDocV1 />
      <FormProductosV1 doc="5" />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card'>
          <div className='w-layout-vflex card-content'>
            <TablaBienesServicios />
            <Footer />
          </div>
        </div>
      </div>
    </>
  )
}